import type { AppConfig } from 'types/common'

export const getConfig = async (): Promise<AppConfig> => {
  const configUrl = `${process.env.PUBLIC_URL}/config/config.json`
  return fetch(configUrl).then(response => response.json())
}
